var render = function (_h,_vm) {
var _obj;
var _c=_vm._c;return _c('div',_vm._g(_vm._b({ref:_vm.data.ref,staticClass:"jz-container",class:[
    _vm.data.class,
    _vm.data.staticClass,
    ( _obj = {
      'container-flex-center': _vm.props.containerFlexCenter,
      column: _vm.props.column,
      fill: _vm.props.fill || _vm.props.flexFill,
      'fill-parent': _vm.props.fillParent,
      flex: _vm.props.flex,
      'flex-center': _vm.props.flexCenter
    }, _obj["overflow-auto"] = _vm.props.overflowAuto, _obj["overflow-x-auto"] = _vm.props.overflowXAuto, _obj["overflow-y-auto"] = _vm.props.overflowYAuto, _obj.row = _vm.props.row, _obj )
  ],style:([_vm.data.style, _vm.data.staticStyle])},'div',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }